<template>
  <MarketplaceCard
    v-if="jbWarranties.config"
    v-model="switchOn"
    :disabled="switchDisabled"
    :logo-path="imageUrl"
    logo-alt="JB Warranties"
    description="Our online system provides contractors with the most comprehensive and easy to use extended service agreement solution."
    learn-more-link="https://www.jbwarranties.com/"
    cy-selector="marketplaceJBW"
  >
    <template #configure>
      <div>
        <div class="link" @click="openModal">Set Up Information</div>
      </div>
    </template>
    <template #modal>
      <div>
        <Modal
          v-if="modalOpen"
          title="Set Up Information - JB Warranties"
          class-name="jb-warranties-config-modal"
          submit-btn-text="Save"
          :saving="saving"
          @submit="saveIntegration"
          @hide-modal="closeModal"
        >
          <div class="d-flex flex-column">
            <h6 class="mb-3 text-bold">Primary Contact</h6>
            <div class="d-flex mb-2">
              <TextField
                v-model="jbWarranties.config.contact_first_name"
                class="flex-1 mr-3"
                label="First Name"
                name="contact_first_name"
              />
              <TextField
                v-model="jbWarranties.config.contact_last_name"
                class="flex-1"
                label="Last Name"
                name="contact_last_name"
              />
            </div>
            <TextField
              v-model="jbWarranties.config.ein"
              label="EIN"
              name="ein"
              hint-label="(Employer Identification Number)"
              placeholder="XX-XXXXXXX"
              class="mb-3"
            />
            <TextField
              v-model="jbWarranties.config.state_license_number"
              label="State License Number"
              name="state_license_number"
              class="mb-3"
            />
            <TextField
              v-model="jbWarranties.config.dealer_id"
              label="Dealer ID"
              name="dealer_id"
              class="mb-3"
            />
            <TextField
              v-model="jbWarranties.config.api_key"
              label="API Key"
              name="api_key"
            />
          </div>
        </Modal>
      </div>
    </template>
  </MarketplaceCard>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Modal from "@/components/Modal.vue";
import TextField from "@/components/TextField.vue";
import JBWarrantiesLogo from "@/images/jb_warranties_logo.png";
import MarketplaceCard from "./MarketplaceCard.vue";

export default {
  components: {
    MarketplaceCard,
    Modal,
    TextField
  },
  data() {
    return {
      switchDisabled: null,
      switchOn: null,
      modalDropVisible: null,
      modalOpen: false,
      saving: false
    };
  },
  computed: {
    ...mapState(["jbWarranties"]),
    imageUrl: {
      get() {
        return JBWarrantiesLogo;
      }
    }
  },
  watch: {
    switchOn: function (newValue, oldValue) {
      if (
        oldValue === null ||
        newValue === oldValue ||
        newValue === this.jbWarranties.config.enabled
      ) {
        return;
      }
      if (this.jbWarranties.config.verified_at == null) {
        return;
      }
      newValue ? this.enableIntegration() : this.disableIntegration();
    },
    "jbWarranties.config.enabled": function (newValue, oldValue) {
      if (oldValue !== newValue) {
        this.refreshTools();
      }
    },
    "jbWarranties.config.api_key": function (newValue, oldValue) {
      if (oldValue !== null && newValue === null) {
        this.refreshModal();
      }
    },
    "jbWarranties.config.dealer_id": function (newValue, oldValue) {
      if (oldValue !== null && newValue === null) {
        this.refreshModal();
      }
    }
  },
  mounted() {
    this.fetchJbWarranties().then(this.refreshTools);
  },
  methods: {
    ...mapActions([
      "fetchJbWarranties",
      "changeJbWarranties",
      "dropJbWarranties"
    ]),
    openModal() {
      this.fetchJbWarranties().then(() => {
        this.modalOpen = true;
        this.refreshModal();
      });
    },
    closeModal() {
      return this.fetchJbWarranties().then(() => {
        this.modalOpen = false;
        this.refreshTools();
      });
    },
    enableIntegration() {
      this.changeJbWarranties({ enabled: true })
        .then(() => {
          window.notify.success("JB Warranties integration enabled!");
        })
        .catch(() => (this.switchOn = false));
    },
    disableIntegration() {
      this.changeJbWarranties({ enabled: false }).then(() => {
        window.notify.success("JB Warranties integration disabled!");
      });
    },
    async saveIntegration() {
      try {
        this.saving = true;
        await this.changeJbWarranties(this.jbWarranties.config);
        window.notify.success("JB Warranties settings saved!");
        this.closeModal();
      } catch (e) {
        // form shows validation errors
      }
      this.saving = false;
    },
    dropIntegration() {
      this.closeModal().then(() => {
        if (this.jbWarranties.config.persisted) {
          this.dropJbWarranties().then(() => {
            window.notify.success("JB Warranties settings deleted!");
          });
        } else {
          window.notify.error(
            "The integration has not been configured yet. There's nothing to delete"
          );
        }
      });
    },
    // Make the state consistent
    refreshTools() {
      this.switchOn = this.jbWarranties.config.enabled;
      this.switchDisabled = this.jbWarranties.config.verified_at == null;
      if (this.switchDisabled) {
        this.switchOn = false;
      }
    },
    refreshModal() {
      if (!this.modalOpen) {
        return;
      }

      // remove blank values
      if (this.jbWarranties.config.api_key === "") {
        this.jbWarranties.config.api_key = null;
      }
      if (this.jbWarranties.config.dealer_id === "") {
        this.jbWarranties.config.dealer_id = null;
      }
    }
  }
};
</script>
